/**
 * İlk ziyaret parlama efekti.
 *
 * Kararlar:
 *   - Oturumda **bir kez**: `sessionStorage`. Aynı sekmede gezinirken tekrar etmez,
 *     yeni oturumda yeniden görünür.
 *   - `prefers-reduced-motion: reduce` -> hiç çalışmaz, işaret bile eklenmez.
 *   - `sessionStorage` erişilemiyorsa (gizli mod, çerez reddi) efekt çalışır ama
 *     "gösterildi" bilgisi saklanamaz; kullanıcıyı engellemez.
 *   - Animasyon yalnızca `transform`/`opacity`/`filter` kullanır — düzen
 *     hesaplaması tetiklenmez, dolayısıyla CLS'ye katkısı yoktur.
 *   - İçerik efektten bağımsız olarak görünür başlar; LCP gecikmez.
 */
(() => {
  const KEY = 'onyxvault:shine-shown';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let alreadyShown = false;
  try {
    alreadyShown = sessionStorage.getItem(KEY) === '1';
  } catch {
    // sessionStorage yoksa efekti bir kez göster, kaydetmeyi atla
  }
  if (alreadyShown) {
    // Oturumda gösterildiyse katmanı DOM'da bırakma — görünmez olsa da
    // gereksiz bir düğüm ve stil hesabı demek.
    const drop = () => document.querySelector('[data-shine]')?.remove();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', drop, { once: true });
    } else {
      drop();
    }
    return;
  }

  const run = () => {
    const layer = document.querySelector('[data-shine]');
    if (!layer) return;

    // Animasyonu bir sonraki kareye bırak: ilk boyama bloklanmasın
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        layer.classList.add('shine--run');
        document.querySelector('.header')?.classList.add('header--shine');

        try {
          sessionStorage.setItem(KEY, '1');
        } catch {
          /* sessizce geç */
        }

        // Bittiğinde DOM'dan çıkar — sayfada gereksiz katman kalmasın
        const cleanup = () => {
          layer.remove();
          document.querySelector('.header')?.classList.remove('header--shine');
        };
        const sweep = layer.querySelector('.shine__sweep');
        if (sweep) {
          sweep.addEventListener('animationend', cleanup, { once: true });
          // Animasyon hiç tetiklenmezse yine de temizle
          setTimeout(cleanup, 2200);
        } else {
          cleanup();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
